module.exports = __webpack_public_path__ + "static/img/knowledgeBase.c4403147.png";